import { useEclipsePlanRecommendation } from '@wix/package-picker-shared-eclipse';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';

export const useAiBannerTitle = () => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const { siteName } = useEclipsePlanRecommendation();

  return siteName
    ? t('premium-purchase-plan.eclipse.ai-recommendation.banner-for-name', {
        siteName,
      })
    : t('premium-purchase-plan.eclipse.ai-recommendation.banner-for-site');
};
